module.exports = __webpack_public_path__ + "static/img/8.ff269df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/eng/8.png
// module id = 5kBZ
// module chunks = 0